import { render, staticRenderFns } from "./OrderHistoryView.vue?vue&type=template&id=1c7b1bc0&scoped=true"
import script from "./OrderHistoryView.vue?vue&type=script&lang=ts"
export * from "./OrderHistoryView.vue?vue&type=script&lang=ts"
import style0 from "./OrderHistoryView.vue?vue&type=style&index=0&id=1c7b1bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7b1bc0",
  null
  
)

export default component.exports